export enum EstateLocationInputMode {
  Update,
  Delete
}
